import React, { memo } from 'react';
import { EdgeProps, getBezierPath, EdgeLabelRenderer } from 'reactflow';

interface DataFlowEdgeData {
  dataType?: string;
  direction?: 'forward' | 'backward' | 'bidirectional';
  label?: string;
}

const DataFlowEdge: React.FC<EdgeProps<DataFlowEdgeData>> = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style = {},
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Determine edge style based on direction
  const getEdgeStyle = () => {
    const direction = data?.direction || 'forward';
    const baseStyle = {
      ...style,
      stroke: '#3b82f6', // blue
      strokeWidth: 2,
    };
    
    switch (direction) {
      case 'backward':
        return {
          ...baseStyle,
          strokeDasharray: '5, 5',
        };
      case 'bidirectional':
        return {
          ...baseStyle,
          strokeWidth: 3,
        };
      default:
        return baseStyle;
    }
  };

  return (
    <>
      <path
        id={id}
        style={getEdgeStyle()}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              background: '#dbeafe', // light blue
              padding: '2px 4px',
              borderRadius: 4,
              fontSize: 10,
              fontWeight: 500,
              pointerEvents: 'all',
              border: '1px solid #93c5fd',
            }}
            className="nodrag nopan"
          >
            {data.label || data.dataType || 'Data'}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default memo(DataFlowEdge);
